<template>
    <div class="dingdan">
<!--        <breadcrumb :routerList="[{to:'/dingd/dingdwxlist',title:'订单管理'},{title:'用车申请'}]" v-if="firstPageFlag!=1"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                	<div class="h-thirdColumn w-newColumn">
                		<el-form-item label="用车编码" prop="sapCode" style="width: 50%;">
                		    <el-input v-model="formInline.id" placeholder="多订单模糊查询请用逗号隔开"></el-input>
                		</el-form-item>
                        <el-form-item label="发货计划编码" prop="sapCode" style="width: 50%;">
                            <el-input v-model="formInline.shipmentCode" placeholder="多订单模糊查询请用逗号隔开"></el-input>
                        </el-form-item>
                    </div>
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="订单号" prop="sapCode" style="width: 50%;">
                            <el-input v-model="formInline.orderNum" placeholder="多订单模糊查询请用逗号隔开"></el-input>
                        </el-form-item>
                        <el-form-item label="国家" prop="country" style="width: 50%;">
                            <el-input v-model="formInline.country" placeholder="请输入国家名称"></el-input>
                        </el-form-item>
                        <!--<el-form-item label="　　通知送货时间" prop="cdatebegin" style="width: 50%;">-->
                            <!--<el-date-picker-->
                                    <!--v-model="formInline.cdatebegin"-->
                                    <!--clearable-->
                                    <!--type="date"-->
                                    <!--value-format="yyyy-MM-dd" >-->
                            <!--</el-date-picker>-->
                            <!--<span class="w-time-to">至</span>-->
                            <!--<el-date-picker-->
                                    <!--v-model="formInline.cdateend"-->
                                    <!--clearable-->
                                    <!--type="date"-->
                                    <!--value-format="yyyy-MM-dd" >-->
                            <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                    </div>
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="通知送货时间" prop="cdatebegin" style="width: 50%;">
                            <el-date-picker
                                    v-model="formInline.cdatebegin"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                            <span class="w-time-to">至</span>
                            <el-date-picker
                                    v-model="formInline.cdateend"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="要求送货时间" prop="requiredDeliveryTimeBegin" style="width: 50%;">
                            <el-date-picker
                                    v-model="formInline.requiredDeliveryTimeBegin"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                            <span class="w-time-to">至</span>
                            <el-date-picker
                                    v-model="formInline.requiredDeliveryTimeEnd"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
				<div class="l-screenBox">
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
						<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
						           @click="imgfalse3">
						    新建用车申请
						</el-button>
					</div>
				</div>
            </div>
        </div>
        <div class="h-table h-mrt30">
            <el-table
                    ref="ddtable"
                    :data="tableData"
                    stripe
            		border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
            		max-height="510"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="selection"
                        fixed
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
            			fixed
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="用车编码"
            			fixed
            			:show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="shipmentCode"
                        label="发货计划编码"
                        fixed
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="orderNum"
                        label="订单号"
                        fixed
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="isStockUp"-->
                        <!--label="是否备货"-->
                        <!--fixed-->
                        <!--:show-overflow-tooltip="true"-->
                        <!--width="120">-->
                    <!--<template scope="scope">-->
                        <!--<div v-if="scope.row.isStockUp==='0'">-->
                            <!--否-->
                        <!--</div>-->
                        <!--<div v-else-if="scope.row.isStockUp==='1'">-->
                            <!--是-->
                        <!--</div>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column-->
                        <!--prop="isWMS"-->
                        <!--label="是否走WMS"-->
                        <!--fixed-->
                        <!--:show-overflow-tooltip="true"-->
                        <!--width="120">-->
                    <!--<template scope="scope">-->
                        <!--<div v-if="scope.row.isWMS==='0'">-->
                            <!--否-->
                        <!--</div>-->
                        <!--<div v-else-if="scope.row.isWMS==='1'">-->
                            <!--是-->
                        <!--</div>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="country"
                        label="国家"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="contact"
                        label="联系人"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="联系电话"
            			:show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="reUnit"
                        label="收货单位"
                        :show-overflow-tooltip="true"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="客户地址"
            			:show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="totalVolume"
                        label="立方数"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="requiredDeliveryTime"
                        label="要求送货时间"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <di style="text-align: left;">
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="updateDetail(scope.row)">编辑
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="handelDetail(scope.row)">查看
                                </el-button>
                                <el-button size="small" class="h-tableLink h-btn"
                                    @click="exportDtExcel(scope.row)">导出
                                </el-button>
                            </di>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
            <pagination :page="formInline" @query="query"/>
            <div style="display:flex;align-items: center;margin-left: 20px">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportDtExcel()">批量导出
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    export default {
        props: ["firstPageFlag"],
        data() {
            return {
				// 展开折叠筛选
				wxCreditFlag:false,
				creditFlagModel:{
					sapCode:"",
					flag:""
				},
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                adminFlag:false,
                //撤回
                chehuidialogFormVisible: false,
                //导入Excel
                uploaddownexcelflag: false,

                fjFlag: null,
                fjCode: null,
                id: null,
                fhStatus: null,
                refid: null,
                reftype: null,
                showFujian: null,

                instid: null,
                showhistory: null,

                imgflag3: false,
                orderTypeList: [],
                orderCategory1AllList:[],
                orderCategory1List:[],

                tableData: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                //表单
                formInline: {
                    pageSize: 10,
                    pageNum: 1,
                    total: 0,
                    id:null,
                    orderNum:null,
                    shipmentCode:null,
                    cdatebegin:null,
                    cdateend:null,
                    country:null,
                    requiredDeliveryTimeBegin:null,
                    requiredDeliveryTimeEnd:null
                },

                customsCode: null,
                billCode: null,
                billDate: null,

                spanArr: [],
                //作废原因
                zfyydialogFormVisible:false,
                zuofeiyy:{
                    id:null,
                    yy:null,
                    bz:null,
                    type:null,
					orderStatus:null,
                },
                ids:[],
                tableSelectedList:[],
                shipToAreaCodeList:[],
                dqcodeList:[],

            }
        },

        created() {
            this.query();
            //    项目
            //     this.listPro();

            //获取所属大区列表
            ss.OrderMainService.getDq().then(rd => {
                this.dqcodeList = rd;
                console.log("dqcodeList", this.dqcodeList);
            });

        },
        methods: {
            handleSelectionChange(lists){
                this.ids = [];
                lists.forEach(item => {
                    this.ids.push(item.id)
                })
            },
            imgfalse3() {
                this.$router.push({path: '/dingd/createCarOrder'})
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                ss.OrderMainService.selectCarPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    //console.log('tableData', this.tableData);
                    this.formInline.total = rd.total || 0;
                });
            },
            //检索
            handleFilter() {
                this.formInline.pageNum = 1;
                this.query();
            },

            // 重置按钮
            resetData() {
                this.formInline.id = null;
                this.formInline.orderNum=null;
                this.formInline.shipmentCode=null;
                this.formInline.cdatebegin=null;
                this.formInline.cdateend=null;
                this.formInline.country=null;
                this.formInline.requiredDeliveryTimeBegin=null;
                this.formInline.requiredDeliveryTimeEnd=null;
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            //批量导出
            // exportExcel(data) {
            //     // var strids = _.join(_.map(this.tableSelectedList,"bid"),",");
            //     // form.strids = strids;
            //     // var date1 = new Date(data.despatchOrderTime.replace(/-/,"/"));
            //     // var date2 = new Date(data.requiredDeliveryTime.replace(/-/,"/"));
            //     data.despatchOrderTime = null;
            //     data.requiredDeliveryTime = null;
            //     updownfile.down("/api/swyl/v1/dingdmain/carApplicfation/downloadExcel", data, "post");
            // },
            exportExcel(item){
                if(item){
                    this.ids = [];
                    this.ids.push(item.id)
                }
                let data = {};
                data.id = this.ids.join(",");
                var form = {
                        pageSize: 10,
                        pageNum: 1,
                        total: 0,
                        id:null,
                        orderNum:null,
                        shipmentCode:null,
                        cdatebegin:null,
                        cdateend:null,
                        country:null,
                        requiredDeliveryTimeBegin:null,
                        requiredDeliveryTimeEnd:null
                    },
                    form = _.clone(this.formInline);
                ss.OrderMainService.downloadBatchExcel(this.formInline).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `用车申请.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
            },
            exportDtExcel(data){
                var data1 = {};
                if(data){
                    data1 = data;
                    data1.despatchOrderTime = null;
                    data1.requiredDeliveryTime = null;
                }else {
                    data1.id = this.ids.join(",");
                }
                ss.OrderMainService.downloadCarExcel(data1).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `用车申请.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
            },
            handleEdit(row) {
                console.log(row)
                this.toEdit(row.orderCategory, row.orderCategory1, row.id);
                // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
            },
            updateDetail(row) {
                this.$router.push({
                    path: "/dingd/updateCarOrder",
                    query: {id: row.id}
                });
            },
            handelDetail(row) {
                this.$router.push({
                    path: "/dingd/checkCarOrder",
                    query: {id: row.id}
                });
            },
            //删除订单
            sapDeleteOrder2(row) {
                if (row.status == '10' || row.status == '30') {
                    this.$msg.confirm("确认删除?", () => {
                        ss.OrderMainService.sapDeleteOrder2(row.bid, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.bid
                    this.zfyydialogFormVisible = true;
                }
            },
            handleDelete(row) {

            },
        },

        mounted() {

        },

    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }

</style>
